const emptyISAEConfiguration = {
  asset: '',
  location: '',
  device_id: '',
  device_tag: '',
  asset_config: {
    controllability: { enabled: false, diagnostic: 'Controllability', did: '' },
    inadequate_air: { enabled: false, diagnostic: 'Inadequate Air', did: '' },
    linkage: { enabled: false, diagnostic: 'Linkage', did: '' },
    hunting: { enabled: false, diagnostic: 'Hunting', did: '' },
    stiction: { enabled: false, diagnostic: 'Stiction', did: '' },
    failure_prediction: {
      enabled: false,
      diagnostic: 'Failure Prediction',
      did: '',
    },
    parameter: { enabled: false, diagnostic: 'Parameter Monitoring', did: [] },
  },
};

export default emptyISAEConfiguration;
